import axios from 'axios';
import { apiRequest } from './apiRequest';
import { CONST } from '../constant';

/**
 * create new group
 * @param data
 * @returns {Promise}
 */
const createGroup = data => {
  return new Promise((resolve, reject) => {
    apiRequest('/api/group/create', CONST.api_method.post, data, true)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 * edit new group
 * @param data
 * @returns {Promise}
 */
const editGroup = data => {
  return new Promise((resolve, reject) => {
    apiRequest('/api/group/edit', CONST.api_method.post, data, true)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 * edit new group
 * @param data
 * @returns {Promise}
 */
const deleteGroup = gid => {
  return new Promise((resolve, reject) => {
    apiRequest('/api/group/' + gid + '/delete', CONST.api_method.post)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};

/**
 * get group information
 * @param data
 * @returns {Promise}
 */
const getGroupDetail = gid => {
  return new Promise((resolve, reject) => {
    apiRequest('/api/group/' + gid, CONST.api_method.get)
      .then(response => {
        resolve(response.data);
      })
      .catch(function(error) {
        reject(error);
      });
  });
};
export { createGroup, editGroup, deleteGroup, getGroupDetail };
